
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { ScriptStore } from "../script.store";
import { HttpClient } from '@angular/common/http';

declare var document: any;

@Injectable()
export class ScriptService {

  private scripts: any = {};

  constructor(private http: HttpClient) {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  public load1() {
    return new Promise((resolve, reject) => {
      this.http.get('./assets/js/clientlibs-base.js').pipe(map(res => res), catchError((error: any): any => {

        console.error('Error at first call');

        resolve(error);
        return observableThrowError(error.json().error || 'Server error');
      }),).subscribe((firstResponse) => {

        let request = this.http.get('./assets/js/clientlibs-all.js');

        request.pipe(
          map(res => res),
          catchError((error: any) => {
            console.error('Error at second call');
            resolve(error);
            return observableThrowError(error.json().error || 'Server error');
          }),)
          .subscribe((secondResponse) => {
            // if (firstResponse) {
            //   let script = document.createElement('script');
            //   script.type = 'text/javascript';
            //   script.src = '../../../ecommerce/assets/js/clientlibs-base.js';
            //   document.getElementsByTagName('head')[0].appendChild(script);
            // }
            // if (secondResponse) {
            //   let script = document.createElement('script');
            //   script.type = 'text/javascript';
            //   script.src = '../../../ecommerce/assets/js/clientlibs-all.js';
            //   document.getElementsByTagName('head')[0].appendChild(script);
            // }
            resolve(true);
          });

      });

    });
  }

  load(...scripts: string[]) {
    var promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      //resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
      else {
        //load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {  //IE
          script.onreadystatechange = () => {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}